import BaseModel from "@/app/base/BaseModel";
import UserProfileModel from "./UserProfileModel";

export default class UserModel extends BaseModel {
    constructor(props) {
        super(props)
        this.UserId = null
        this.Mail = ''
        this.Password = ''
        this.RegisterDatetime = ''
        this.delete = null
        this.profile = {}
        this.status = 0
        this.mws_channel = ''

        this.syncProps(props)
    }

    rawValue() {
        const val = super.rawValue();
        if (val.role_id) {
            val.role_id = val.role_id.id
        }
        if (val.customer)
            val.customer = val.customer._id

        return val
    }

    rawValueUserGroupRole() {
        const val = super.rawValue();
        if (val.customer)
            val.customer = val.customer._id

        return val
    }
}

UserModel.STATUS = {
    0: '公開',
    1: '未公開',
    2: '業務進行中',
    3: '完了',
}

